import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import qs from 'qs';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import RootRef from '@material-ui/core/RootRef';

import Layout from 'components/common/Layout';
import Button from 'components/common/Button';
import Link from 'components/common/Link';

import IconFile from 'components/icons/IconFile';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const styles = () => ({
  grid: {
    position: 'relative',
    top: '-10%',
    minHeight: 'calc(100vh - 104px)',
    zIndex: 1,
  },
  typographyTitle: {
    fontSize: pxToRem(18, 16),
    letterSpacing: 0.2,
    lineHeight: pxToEm(30, 18),
    marginBottom: 16,
    fontWeight: 700,
  },
  button: {
    minWidth: 166,
  },
  icon: {
    position: 'relative',
  },
  iconFile: {
    width: 54,
    height: 68,
  },
  iconTypography: {
    position: 'absolute',
    top: 38,
    left: 2,
    width: 34,
  },
  typographyText: {
    fontSize: pxToRem(16, 16),
    letterSpacing: 0.2,
    lineHeight: pxToEm(30, 16),
    marginBottom: 16,
  },
});

class Download extends Component {
  componentDidMount() {
    setTimeout(() => {
      if (this.linkRef) {
        this.linkRef.click();
      }
    }, 1000);
  }

  render() {
    const { extension, fileName, downloadHref, classes } = this.props;

    return (
      <Layout variant="error">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Download File
          </title>
        </Helmet>
        <Grid
          className={classes.grid}
          container
          direction="column"
          alignItems="center"
          justify="center"
          spacing={24}
        >
          <Grid item>
            <Typography
              className={classes.typographyTitle}
              variant="title"
              align="center"
              color="secondary"
            >
              Your report is ready!
            </Typography>
            <RootRef
              rootRef={(linkRef) => {
                this.linkRef = linkRef;
              }}
            >
              <Link
                color="secondary"
                underline
                download={downloadHref}
                href={downloadHref}
                target="_blank"
              >
                If download didn&apos;t start automatically, please,
                click this link or button below.
              </Link>
            </RootRef>
          </Grid>
          <Grid item>
            <div className={classes.icon}>
              <IconFile className={classes.iconFile} />
              <Typography
                className={classes.iconTypography}
                variant="caption"
                color="secondary"
                align="center"
              >
                {extension ? `.${extension}` : ''}
              </Typography>
            </div>
          </Grid>
          {fileName &&
            <Grid item>
              <Typography
                className={classes.typographyText}
                variant="title"
                align="center"
                color="secondary"
                gutterBottom
              >
                {fileName}
              </Typography>
            </Grid>
          }
          <Grid item>
            <Button
              className={classes.button}
              variant="raised"
              color="primary"
              href={downloadHref}
              download={downloadHref}
            >
              Download
            </Button>
          </Grid>
        </Grid>
      </Layout>
    );
  }
}

Download.propTypes = {
  extension: PropTypes.string,
  fileName: PropTypes.string,
  downloadHref: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    typographyTitle: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

Download.defaultProps = {
  extension: null,
  fileName: null,
  downloadHref: null,
};

const mapStateToProps = (store, ownProps) => {
  const params = qs.parse(ownProps.location.search, { ignoreQueryPrefix: true });
  const extension = params['Report File Name'] ? params['Report File Name'].split('.')[1] : null;
  return {
    extension,
    fileName: params['Report File Name'],
    downloadHref: params['Report File Name']
      ? `/rest/report/download_report/?Report+File+Name=${params['Report File Name']}` : null,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(Download));



// WEBPACK FOOTER //
// ./src/pages/common/Download.js